import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Zap, Menu, X } from 'lucide-react';

export default function Navbar({ onBookDemo }) {
  const [open, setOpen] = useState(false);
  return (
    <nav data-testid="landing-navbar" className="sticky top-0 z-50 bg-white/90 backdrop-blur-lg border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <Zap className="h-8 w-8 text-blue-600" />
          <span className="text-xl font-bold tracking-tight text-slate-900" style={{ fontFamily: 'Manrope' }}>Zap AI</span>
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <Link to="/#solutions" className="text-sm font-medium text-slate-600 hover:text-blue-600">Solutions</Link>
          <Link to="/#why-zap" className="text-sm font-medium text-slate-600 hover:text-blue-600">Why Zap AI</Link>
          <Link to="/#how-it-works" className="text-sm font-medium text-slate-600 hover:text-blue-600">How It Works</Link>
        </div>
        <div className="hidden md:flex items-center gap-3">
          {onBookDemo ? (
            <Button data-testid="nav-book-demo-btn" onClick={onBookDemo} className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6">
              Book a Demo
            </Button>
          ) : (
            <Link to="/#contact">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6">
                Book a Demo
              </Button>
            </Link>
          )}
        </div>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t px-6 py-4 space-y-3 bg-white">
          <Link to="/#solutions" className="block text-sm font-medium text-slate-600" onClick={() => setOpen(false)}>Solutions</Link>
          <Link to="/#why-zap" className="block text-sm font-medium text-slate-600" onClick={() => setOpen(false)}>Why Zap AI</Link>
          <Link to="/#how-it-works" className="block text-sm font-medium text-slate-600" onClick={() => setOpen(false)}>How It Works</Link>
          {onBookDemo && (
            <div className="pt-2">
              <Button onClick={() => { setOpen(false); onBookDemo(); }} className="w-full bg-blue-600 text-white">Book a Demo</Button>
            </div>
          )}
        </div>
      )}
    </nav>
  );
}
